<template>
  <div class="form-enterpreneur FormEnterpreneur.vue">
        <div class="switch__container">
          <input :id="id" class="switch" type="checkbox" :value="value">
          <label :for="id"></label>
        </div>
  </div>
</template>

<script>
  export default {
    name: 'checkboxSwitcher',
    data () {
      return {
        id: null,
      }
    },
    props:[
      'value'
    ],
    methods: {
      inputValue(id){
        if(id == '28'){
          return "Propaganda"
        } else if(id == '29'){
          return "Redes Sociais"
        } else if(id == '30'){
          return "Inbound"
        } else if(id == '31') {
          return "Tecnologia"
        }
      }
    },
    mounted () {
      this.id = this._uid
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/checkboxSwitcher.vue